import { useMemo } from "react";
import useIsMobile from "../../../device/useIsMobile.js";
export const useAccommodationInput = ({ name ='accommodation' , label , icon ='user' , literals ={} , defaultValue , discounts , validate , residents , disabled =false  })=>{
    const isMobile = useIsMobile();
    const newLiterals = useMemo(()=>isMobile ? {
            accommodationTitle: literals.accommodationLabel,
            agePersonLabel: `${literals.childLabel} #number#`,
            ...literals
        } : literals, [
        isMobile,
        literals
    ]);
    return useMemo(()=>({
            name,
            defaultValue,
            label,
            icon: isMobile ? '' : icon,
            literals: newLiterals,
            discounts: discounts,
            residents: residents,
            resident: {
                name: 'resident',
                value: residents?.items[0]
            },
            discount: {
                name: 'discount',
                value: discounts?.items[0]
            },
            validate,
            disabled
        }), [
        defaultValue,
        disabled,
        discounts,
        icon,
        isMobile,
        label,
        name,
        newLiterals,
        residents,
        validate
    ]);
};
export default useAccommodationInput;

//# sourceMappingURL=useAccommodationInput.js.map